<div
  class="header_container"
  [ngClass]="{'header_container--transparent' : transparentMode}">
  <app-navigation [expanded]="navExpanded">
  </app-navigation>

  @if (authService.isCorporateAdmin && selectedOfficeGroupId) {
    <div
      class="form_field-wrapper form_field-wrapper--small">
      <mat-select
        class="form_control form_control--small"
        disableOptionCentering
        panelClass="dropdown"
        name="office_group"
        [(ngModel)]="selectedOfficeGroupId"
        (selectionChange)="submit()"
        aria-label="{{ 'officeGroup' | translate }}">
        @for (group of officeGroups; track group.id) {
          <mat-option [value]="group.id">{{ group.name }}</mat-option>
        }
      </mat-select>
    </div>
  }

  <a class="header_link" target="_blank" [routerLink]="['/help']">{{ 'help' | translate }}</a>
  @if (!authService.isTechallUser || !techallService.currentSession) {
    <a class="header_link" [routerLink]="['/contact']">{{ 'contactUs' | translate }}</a>
  }
  <app-language-switcher></app-language-switcher>
</div>

@if (isLoading) {
  <app-loader [transparent]="true"></app-loader>
}